module.exports = __webpack_public_path__ + "static/media/folha2.f5d1be5c.png";